(function () {
  var selector = "[data-rvrn-reveal], .rvrn-reveal";
  var observer = null;
  var supportsObserver = "IntersectionObserver" in window;
  var isDesignMode = window.Shopify && window.Shopify.designMode;

  function reveal(item) {
    item.classList.add("is-visible");
    item.dataset.rvrnRevealReady = "true";
  }

  function getObserver() {
    if (observer || !supportsObserver) return observer;

    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        var delay = parseInt(entry.target.getAttribute("data-rvrn-reveal-delay") || "0", 10);
        window.setTimeout(function () {
          reveal(entry.target);
        }, delay);

        observer.unobserve(entry.target);
      });
    }, { threshold: 0.15 });

    return observer;
  }

  function init(scope) {
    var root = scope || document;
    var items = Array.prototype.slice.call(root.querySelectorAll(selector));
    if (!items.length) return;

    if (isDesignMode || !supportsObserver) {
      items.forEach(reveal);
      return;
    }

    var io = getObserver();
    items.forEach(function (item) {
      if (item.dataset.rvrnRevealReady === "true") return;
      item.dataset.rvrnRevealReady = "pending";
      io.observe(item);
    });
  }

  window.RVRNReveal = window.RVRNReveal || {};
  window.RVRNReveal.init = init;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });

  document.addEventListener("shopify:block:select", function (event) {
    init(event.target);
  });
})();
